import { Injectable } from '@angular/core';

@Injectable()
export class DynamicTemplateBuilder {

    public prepareTemplate (componentNameString: any , entity: any, vcd: boolean) {
        let componentName = vcd  ? (componentNameString + '-vcd') : (componentNameString + '-vc');
        // Add entity input below to the below date if required
        let template = `<${componentName}></${componentName}>`;
        return template;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dynamic-dps/template.builder.ts